import React, { useEffect, useState } from 'react'
import {
  Box,
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  Typography,
} from '@material-ui/core'

import { LoadingFeedback, RiskAssumedInfo } from 'components'
import { Complete } from 'views/Incidents/components/IncidentsForm/components'

import useIncidentManegement from 'hooks/useIncidentManegement'
import useIncident from 'hooks/useIncident'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import formatters from 'helpers/formatters'
import incidentConstants from 'constants/incidents'
import constants from 'constants/index'

const DetalingStep = ({ refresh }) => {
  const { INCIDENT_INFORMATION_STEPS } = incidentConstants

  const { wantsToAdvanceStep, resetAdvanceStep, incident, handleNext, isShow } =
    useIncidentManegement()
  const { activeStep: completeFormActiveStep } = useIncident()
  const snackbar = useSnackbar()

  const isRiskAssumed = incident.riskAssumptions?.detaling?.riskAssumed

  const [showCompleteForm, setShowCompleteForm] = useState(
    incident?.shouldNotifyAnpd || !incident?.simplifiedForm,
  )
  const [loading, setLoading] = useState(false)

  const handleChangeShowCompleteForm = () => {
    setShowCompleteForm((showCompleteForm) => !showCompleteForm)
  }

  const submitForm = () => {
    const form = document.getElementById(
      INCIDENT_INFORMATION_STEPS[completeFormActiveStep].buttonId,
    )

    if (form) form.dispatchEvent(new Event('submit'))

    resetAdvanceStep()
  }

  const concludeStep = async () => {
    try {
      setLoading(true)

      await service.dponet.incidents.concludeStep({
        incidentId: incident.id,
        step: 'detaling',
      })

      resetAdvanceStep()
      handleNext()
    } catch (error) {
      snackbar.open({
        message: formatters.errorMessage(error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
      resetAdvanceStep()
    }
  }

  useEffect(() => {
    if (wantsToAdvanceStep) {
      if (isRiskAssumed) {
        resetAdvanceStep()
        handleNext()
        return
      }

      if (showCompleteForm) {
        submitForm()
      } else {
        concludeStep()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantsToAdvanceStep])

  return (
    <>
      <LoadingFeedback open={loading} />
      <Box
        paddingBottom={2}
        id={constants.incidents.INCIDENT_MAIN_DRIVER_STEP_7}
      >
        <Grid container spacing={3}>
          {!incident?.shouldNotifyAnpd && (
            <Grid item xs={12}>
              <Paper component={Box} p={2}>
                <Typography variant="body1" gutterBottom>
                  O Encarregado de Proteção de Dados (DPO) responsável concluiu
                  que não será necessário notificar os titulares de dados e a
                  ANPD pois não houve dano e/ou risco relevante, portanto, esta
                  etapa não será exigida. No entanto, se desejar detalhar como
                  parte da documentação, basta ativá-la no botão abaixo.
                </Typography>
                <FormControlLabel
                  control={
                    <Switch
                      defaultChecked={showCompleteForm}
                      color="primary"
                      onChange={handleChangeShowCompleteForm}
                      value={showCompleteForm}
                    />
                  }
                  label="Ativar relatório detalhado"
                  labelPlacement="end"
                  disabled={!incident?.simplifiedForm || isShow}
                />
              </Paper>
            </Grid>
          )}

          {showCompleteForm && (
            <Grid item xs={12}>
              {isRiskAssumed ? (
                <RiskAssumedInfo
                  incident={incident}
                  isShow={isShow}
                  refresh={refresh}
                  step={constants.incidentRiskAssumption.DETALING_ENUM}
                  successMessage="O formulário ANPD foi reativado com sucesso."
                  message="O Risco foi assumido para não preencher o formulário ANPD, portanto, esta etapa não será exigida."
                  buttonText="Preencher formulário"
                  confirmMessage="Tem certeza que deseja cancelar o risco assumido e reativar o preenchimento do formulário ANPD?"
                />
              ) : (
                <Complete incident={incident} refresh={refresh} />
              )}
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  )
}

export default DetalingStep
